function updatePrice() {
  const qtyInput = document.querySelector('[name="quantity"]');
  const priceEl = document.querySelector('span.price');
  const compareEl = document.querySelector('span.compare-at-price');
  if (!qtyInput || !priceEl) return;

  // Sauvegarde les prix unitaires au premier appel
  if (!priceEl.dataset.unitPrice) {
    const raw = priceEl.innerText.trim().replace(/[^\d,]/g, '').replace(',', '.');
    priceEl.dataset.unitPrice = raw;
  }
  if (compareEl && !compareEl.dataset.unitPrice) {
    const rawCompare = compareEl.innerText.trim().replace(/[^\d,]/g, '').replace(',', '.');
    compareEl.dataset.unitPrice = rawCompare;
  }

  const unitPrice = parseFloat(priceEl.dataset.unitPrice);
  const qty = parseInt(qtyInput.value) || 1;
  if (isNaN(unitPrice)) return;

  priceEl.innerText = (unitPrice * qty).toFixed(2).replace('.', ',') + ' €';

  if (compareEl) {
    const unitCompare = parseFloat(compareEl.dataset.unitPrice);
    if (!isNaN(unitCompare)) {
      compareEl.innerText = (unitCompare * qty).toFixed(2).replace('.', ',') + ' €';
    }
  }
}

document.addEventListener('click', function(e) {
  if (
    e.target.classList.contains('quantity-plus') ||
    e.target.classList.contains('quantity-minus')
  ) {
    setTimeout(updatePrice, 50);
  }
}, true);

document.addEventListener('input', function(e) {
  if (e.target && e.target.name === 'quantity') updatePrice();
}, true);
